import { Epic, ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { SignupService } from "../../services/SignupService";
import { RootAction } from "../types";
import {
  SIGN_UP,
  SignUpActionFailure,
  signUpActionFailure,
  SignUpActionSuccess,
  signUpActionSuccess,
} from "./actions";

export const signupEpic: Epic<
  RootAction,
  SignUpActionSuccess | SignUpActionFailure,
  any,
  any
> = (action$, state, any) =>
  action$.pipe(
    ofType(SIGN_UP),
    switchMap((action) =>
      from(
        SignupService.signUp({
          entityId: action.entityId,
          email: action.email,
          password: action.password,
          entityName: action.entityName,
          firstName: action.firstName,
          lastName: action.lastName,
          roles: action.roles,
          title: action.title,
          phoneNumber: action.phoneNumber,
          professionalPosition: action.professionalPosition,
          location: action.location,
          language: action.language,
          isExpert: action.isExpert,
          expertiseDomain: action.expertiseDomain,
          specialties: action.specialties,
          description: action.description,
          languages: action.languages,
          barAssociation: action.barAssociation,
          educations: action.educations,
          experiences: action.experiences,
          jurisdictions: action.jurisdictions,
        })
      ).pipe(
        mergeMap((res) => {
          return [signUpActionSuccess()];
        }),
        catchError((error) =>
          of(error).pipe(mergeMap(() => [signUpActionFailure()]))
        )
      )
    )
  );
